export const VersionStore = {
    Apple: { value: 0, label: 'Apple' },
    Google: { value: 1, label: 'Google' }
};

export const VersionOptions = {
    Store: Object.entries(VersionStore).map(([, data]) => data),

    Status: [
        { value: 0, label: 'Unsupport' },
        { value: 1, label: 'Support' },
        { value: 2, label: 'Active' }
    ]
};
